export default {
    colons: (val) => (`${val}:`)
};
